import "./EditIOProperties/EditIOPropertiesComponent";
import "./IOProperties.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import IOPropertiesComponentController from "./IOPropertiesComponentController";

export default class IOPropertiesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            equipmentFunctionalityType: "<",
        };
        this.controller = IOPropertiesComponentController;
        this.templateUrl = "/App/Components/EquipmentFunctionalityType/IOProperties/IOProperties.html";
    }
}

module("mmManagePortal").component("irFunctionalityIoProperties", new IOPropertiesComponent());
